import { Typography } from "@mui/material";
import { UnSuccessfulImports as AchievementsUnSuccessfulImports } from "components/Layout/Achievement/AchievementImportList/UnSuccessfullImports";
import { UnSuccessfulImports as AutomationsUnsuccessfulImports } from "components/Layout/Campaign/Automations/AutomationsImportList/UnSuccessfulImports";
import { UnSuccessfulImports as CampaignsUnsuccessfulImports } from "components/Layout/Campaign/Direct/CampaignImportList/UnSuccessfulImports";
import { UnSuccessfulImports as ReferralsUnsuccessfullImports } from "components/Layout/Campaign/Referrals/ReferralsImportList/UnsuccessfullImports";
import { UnsuccessfulCustomEventSchema } from "components/Layout/CustomEvent/SchemaImportList/CustomEventSchemaImportList";
import { UnsuccessfulImports as CustomEventSchemaUnsuccessfulImports } from "components/Layout/CustomEvent/SchemaImportList/UnsuccessfullImports";
import { UnsuccessfulImports as RewardsUnsuccessfulImports } from "components/Layout/Reward/RewardImportList/UnsuccessfullImports";
import { UnSuccessfulImports as WalletUnSuccessfulImports } from "components/Layout/WalletType/WalletTypeImportList/UnsuccessfulImports";
import { UnsuccessfulImportedWalletData } from "components/Layout/WalletType/WalletTypeImportList/WalletTypeImportList";
import { useMessage } from "hooks/intl";
import { UnSuccessfulImportedAchievementData } from "types/achievements";
import { ImportType, UnSuccessfulImportedCampaignData } from "types/campaigns";
import { UnsuccessfullReward } from "types/rewards";
import { ImportTableWrapper } from "./ImportTableWrapper";
import { useStyles } from "./styles";
import { Tab } from "./Tabs/Tabs";

interface Props {
  unSuccessfullImport: {
    [Tab.WALLET]?: UnsuccessfulImportedWalletData[];
    [Tab.CUSTOM_EVENT]?: UnsuccessfulCustomEventSchema[];
    [Tab.REWARDS]?: UnsuccessfullReward[];
    [Tab.ACHIEVEMENTS]?: UnSuccessfulImportedAchievementData[];
    [Tab.CAMPAIGNS]?: UnSuccessfulImportedCampaignData[];
    [Tab.REFERRALS]?: UnSuccessfulImportedCampaignData[];
    [Tab.AUTOMATIONS]?: UnSuccessfulImportedCampaignData[];
  };
}

export const UnSuccessfulImports = ({ unSuccessfullImport }: Props) => {
  const { message } = useMessage();
  const classes = useStyles();

  const areWallets =
    unSuccessfullImport[Tab.WALLET] &&
    unSuccessfullImport[Tab.WALLET].length > 0;
  const areCustomEvents =
    unSuccessfullImport[Tab.CUSTOM_EVENT] &&
    unSuccessfullImport[Tab.CUSTOM_EVENT].length > 0;
  const areRewards =
    unSuccessfullImport[Tab.REWARDS] &&
    unSuccessfullImport[Tab.REWARDS].length > 0;
  const areAchievements =
    unSuccessfullImport[Tab.ACHIEVEMENTS] &&
    unSuccessfullImport[Tab.ACHIEVEMENTS].length > 0;
  const areCampaigns =
    unSuccessfullImport[Tab.CAMPAIGNS] &&
    unSuccessfullImport[Tab.CAMPAIGNS].length > 0;
  const areReferrals =
    unSuccessfullImport[Tab.REFERRALS] &&
    unSuccessfullImport[Tab.REFERRALS].length > 0;
  const areAutomations =
    unSuccessfullImport[Tab.AUTOMATIONS] &&
    unSuccessfullImport[Tab.AUTOMATIONS].length > 0;

  return (
    <>
      <Typography className={classes.importTitle}>
        {message({ id: "actionRequired" })}
      </Typography>
      {areWallets && (
        <ImportTableWrapper tableName={message({ id: "wallets" })}>
          <WalletUnSuccessfulImports
            wallets={
              unSuccessfullImport[
                Tab.WALLET
              ] as UnsuccessfulImportedWalletData[]
            }
            disableTitle
            importType="global"
          />
        </ImportTableWrapper>
      )}
      {areCustomEvents && (
        <ImportTableWrapper tableName={message({ id: "customEventSchemas" })}>
          <CustomEventSchemaUnsuccessfulImports
            disableTitle
            importType="global"
            customEventSchemas={
              unSuccessfullImport[
                Tab.CUSTOM_EVENT
              ] as UnsuccessfulCustomEventSchema[]
            }
          />
        </ImportTableWrapper>
      )}
      {areRewards && (
        <ImportTableWrapper tableName={message({ id: "rewards" })}>
          <RewardsUnsuccessfulImports
            disableTitle
            rewards={unSuccessfullImport[Tab.REWARDS] as UnsuccessfullReward[]}
            importType="global"
          />
        </ImportTableWrapper>
      )}
      {areAchievements && (
        <ImportTableWrapper tableName={message({ id: "achievements" })}>
          <AchievementsUnSuccessfulImports
            disableTitle
            achievements={
              unSuccessfullImport[
                Tab.ACHIEVEMENTS
              ] as UnSuccessfulImportedAchievementData[]
            }
            importType={ImportType.GLOBAL}
          />
        </ImportTableWrapper>
      )}
      {areCampaigns && (
        <ImportTableWrapper tableName={message({ id: "campaigns" })}>
          <CampaignsUnsuccessfulImports
            disableTitle
            campaigns={
              unSuccessfullImport[
                Tab.CAMPAIGNS
              ] as UnSuccessfulImportedCampaignData[]
            }
            importType="global"
          />
        </ImportTableWrapper>
      )}
      {areReferrals && (
        <ImportTableWrapper tableName={message({ id: "referrals" })}>
          <ReferralsUnsuccessfullImports
            disableTitle
            referrals={
              unSuccessfullImport[
                Tab.REFERRALS
              ] as UnSuccessfulImportedCampaignData[]
            }
            importType={ImportType.GLOBAL}
          />
        </ImportTableWrapper>
      )}

      {areAutomations && (
        <ImportTableWrapper tableName={message({ id: "automations" })}>
          <AutomationsUnsuccessfulImports
            disableTitle
            campaigns={
              unSuccessfullImport[
                Tab.AUTOMATIONS
              ] as UnSuccessfulImportedCampaignData[]
            }
            importType={ImportType.GLOBAL}
          />
        </ImportTableWrapper>
      )}
    </>
  );
};
